import { useEffect, useMemo, useState } from 'react';
import { Autocomplete, CircularProgress, TextField } from '@mui/material';

import { useField } from '@unform/core';

type TAutoCompleteOption = {
    status: string;
}

interface IAutoCompleteStatusProps {
    isExternalLoading?: boolean;
}

export const AutoCompleteStatus: React.FC<IAutoCompleteStatusProps> = ({ isExternalLoading = false }) => {

    const { fieldName, registerField, defaultValue, error, clearError } = useField('status');
    const [selectedStatus, setSelectedStatus] = useState<string | undefined>(defaultValue);
    const [isLoading, setIsLoading] = useState(true);
    const [opcoes, setOpcoes] = useState<TAutoCompleteOption[]>([]);
    const [busca, setBusca] = useState('');

    useEffect(() => {
        registerField({
            name: fieldName,
            getValue: () => selectedStatus,
            setValue: (_, newSelectedStatus) => setSelectedStatus(newSelectedStatus),
        });
    }, [registerField, fieldName, selectedStatus]);

    useEffect(() => {
        setIsLoading(false)
        setOpcoes([
            { status: "ATIVO" },
            { status: "INATIVO" }
        ])
    }, [busca]);

    const autoCompleteSelectedOption = useMemo(() => {
        if (!selectedStatus) return null;

        const selectedOption = opcoes.find(opcao => opcao.status === selectedStatus);
        if (!selectedOption) return null;

        return selectedOption;
    }, [selectedStatus, opcoes]);


    return (
        <Autocomplete
            openText='Abrir'
            closeText='Fechar'
            noOptionsText='Sem opções'
            loadingText='Carregando...'
            clearText='Limpar'

            disablePortal

            options={opcoes}
            getOptionLabel={(option) => option.status ?? option}
            loading={isLoading}
            disabled={isExternalLoading}
            value={autoCompleteSelectedOption}
            onInputChange={(_, newValue) => setBusca(newValue)}
            onChange={(_, newValue) => { setSelectedStatus(newValue?.status); setBusca(''); clearError(); }}
            popupIcon={(isExternalLoading || isLoading) ? <CircularProgress size={28} /> : undefined}
            renderInput={(params) => (
                <TextField
                    {...params}

                    label="Status"
                    error={!!error}
                    helperText={error}
                />
            )}
        />
    );
};